import { Component } from "react";
import { Button, ButtonGroup, Col, Form, InputGroup, Modal, ToggleButton, ToggleButtonGroup } from "react-bootstrap";
import Select from 'react-select'
import axiosInstance from "../../axiosInstance";
class StbForm extends Component{
    
    constructor(props){
        super(props);
        this.state = {
            tv_brand_id:null,
            stb_package_ids:null,
            additional:false,
            selected_tv_brand:null,
            selected_packages:null,
            edit:{
                showModal:false,
                reference : null
            },
            delete:{
                showModal:false
            }
            
        }
    }

    getSelectedTvBrand(){
        if(this.props.exists){
            return this.props.tv_brands.filter(e => e.value == this.props.element.tv_brand_id)[0];
        }
        return null;
    }

    getSelectedPackages(){
        if(this.props.exists){
            let result = this.props.stb_packages.filter(e => this.props.element.stb_package_ids.includes(e.value));
            return result;
        }
        return null;
    }

    on_tv_brand_change(e) {
        this.setState({
            selected_tv_brand:e,
            tv_brand_id: e.value
        })
    }
    componentDidMount(){
        if(this.props.exists){
            let tv_brand = this.getSelectedTvBrand();
            let packages = this.getSelectedPackages();
            this.setState({
                selected_tv_brand:tv_brand,
                selected_packages:packages,
                tv_brand_id : tv_brand?.value,
                stb_package_ids : packages.map((element,_) => element.value),
                additional:this.props.element.additional
            })
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot){
        if(this.props.tv_brands.length !== prevProps.tv_brands.length){
            let tv_brand = this.getSelectedTvBrand();
            this.setState({
                selected_tv_brand:tv_brand,
                tv_brand_id : tv_brand?.value
            })
        }

        if(this.props.stb_packages.length !== prevProps.stb_packages.length){
            let packages = this.getSelectedPackages();
            this.setState({
                selected_packages:packages,
                stb_package_ids: packages?.map((element,_) => element.value),
            })
        }
    }


    editStb(){
        axiosInstance.put('tickets/stbs/'+ this.props.element.id,{
            stb_package_ids : this.state.stb_package_ids,
            additional : this.state.additional,
            tv_brand_id : this.state.tv_brand_id
        })
        .then(response => response.data.data)
        .then(data => {
            this.setState({
                edit:{
                    ...this.state.edit,
                    showModal:false
                }
            })
        })
        .catch(err => {
            console.log(err);
        })
    }


    deleteStb(){
        axiosInstance.delete('/tickets/stbs/' + this.props.element.id)
        .then(response => response.data)
        .then(data => {
            this.setState({
                delete : {
                    showModal: false
                }
            })
            this.props.update();
        })
        .catch(err => {
            console.log(err);
        })
    }

    render(){
        return(
            <Form.Row className="stb-form">
                <Form.Group as={Col} md="12">
                    <Form.Row>
                        <Form.Group as = {Col} md={{span : 2,offset:0}}>
                            <Form.Label>STB {this.props.index}</Form.Label>
                        </Form.Group>
                        {this.props.isEditable && this.props.exists && <Form.Group as = {Col} md={{span : 1,offset:8}}>
                            <Button variant = "warning" onClick = {() => {
                                this.setState({
                                    edit : {
                                        ...this.state.edit,
                                        showModal: true
                                    }
                                })
                            }}><i class="fas fa-edit"></i></Button>
                        </Form.Group>}
                        {this.props.isEditable && this.props.exists && <Form.Group as = {Col} md={{span : 1,offset:0}}>
                            <Button variant = "danger" onClick = {() => {
                                this.setState({
                                    delete:{
                                        ...this.state.delete,
                                        showModal: true
                                    }
                                })
                            }}><i class="fas fa-trash-alt"></i></Button>
                        </Form.Group>}
                    </Form.Row>
                </Form.Group>
                <Form.Group as={Col} md="12">
                    <Form.Row>
                        <Form.Group as={Col} md="6" >
                            <Form.Label>ჩასართავი პაკეტი</Form.Label>
                            <Select
                                maxMenuHeight={170} 
                                options={this.props.stb_packages}
                                isDisabled={!this.props.isEditable}
                                
                                onChange={(e) => {
                                    this.setState({
                                        selected_packages:e,
                                        stb_package_ids:e ?e.map((element,index) => element.value) : e
                                    })
                                }} 
                                value={this.state.selected_packages}
                                isMulti = {true}
                                placeholder="აირჩიეთ" />
                        </Form.Group>
                        <Form.Group as={Col} md="6" sm="12">
                            <Form.Label>Tv ბრენდი</Form.Label>
                            <Select
                                maxMenuHeight={170} 
                                isDisabled={!this.props.isEditable}
                                options={this.props.tv_brands} 
                                onChange={(e) => this.on_tv_brand_change(e)}
                                value= {this.state.selected_tv_brand} 
                                placeholder="აირჩიეთ" 
                                />
                                
                        </Form.Group>
                        {
                            (this.props.exists) &&
                            <Form.Group as={Col} md="6">
                                <Form.Label>MAC</Form.Label>
                                <Form.Control
                                    type="text"
                                    name="mac"
                                    disabled={true}
                                    value = {this.props.element.mac ?? ""}
                                />
                            </Form.Group>
                        }
                        <Form.Group as={Col} md="4">
                            <Form.Check 
                                checked={this.state.additional} 
                                type="checkbox" 
                                label="დამატებითი STB" 
                                disabled={!this.props.isEditable}
                                onChange={(e) => {
                                    this.setState({
                                        additional: e.target.checked
                                    })  
                                }} />            
                        </Form.Group>
                    </Form.Row>
                </Form.Group>
                <Modal
                    show={this.state.edit.showModal} 
                    centered
                    onHide = {() => {
                        this.setState({
                            edit : {
                                ...this.state.edit,
                                showModal : false
                            }
                        })
                    }}
                >
                    <Modal.Header closeButton>
                        <Modal.Title>STB რედაქტირება</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                       დანამდვილებით გსურთ რედაქტირება?
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="success" onClick={(event) => {
                            this.editStb()
                        }} >
                            რედაქტირება
                        </Button>
                    </Modal.Footer>
                </Modal>
                <Modal
                    show={this.state.delete.showModal} 
                    centered
                    onHide = {() => {
                        this.setState({
                            delete : {
                                ...this.state.delete,
                                showModal : false
                            }
                        })
                    }}
                >
                    <Modal.Header closeButton>
                        <Modal.Title>STB წაშლა</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                       დანამდვილებით გსურთ წაშლა?
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="success" onClick={(event) => {
                            this.deleteStb()
                        }} >
                            წაშლა
                        </Button>
                    </Modal.Footer>
                </Modal>
            </Form.Row>
        );
    }
}
export default StbForm;